import { flow, set } from 'lodash/fp';

import flexiLimitsImage from './images/flexi-limits.svg';

// @ts-expect-error - Automatic, Please fix when editing this file
const manufactureBaseChoosableProduct = (product, onClick) => {
  const buttonText = 'Select bundles';
  const selectButton = {
    analyticsLabel: buttonText,
    onClick,
    showButtonTextWhenCondensed: true,
    text: buttonText,
    variants: ['border', 'white'],
  };
  return flow(
    set('name', 'choosable 60'),
    set('content.longForm', [
      'Start with our base bundle of teeth and emergency ambulance, then choose the extras bundles that suit your needs.',
    ]),
    set('customLabel', 'Build your own cover'),
    set('showFromWithPrice', true),
    set('extras.included', []),
    set('selectButton', selectButton),
    set('columnOverlayContent', {
      extraText: 'to unlock inclusions',
      image: {
        alt: 'Illustration of inclusion types',
        src: flexiLimitsImage.src,
      },
      linkText: 'Customise your cover',
      onClick,
    }),
  )(product);
};

export default manufactureBaseChoosableProduct;
